export interface DaySelectProps {
    selectedDate: Date;
    ariaLabel?: string;
    id?: string;
    onChange: (e: React.ChangeEvent<HTMLSelectElement>, key: string) => void;
}

const DaySelect = (props: DaySelectProps) => {
    const { selectedDate, ariaLabel, id, onChange } = props;

    return (
        <span className="date-select">
            <label htmlFor={id} className="sr-only">
                {ariaLabel}
            </label>
            <select
                className="start-date-day-input"
                onChange={(e) => onChange(e, 'day')}
                aria-label={ariaLabel || ''}
                id={id || ''}
                value={selectedDate.getDate()}
            >
                {[...Array(32)].map(
                    (_a, i: number) =>
                        i > 0 && (
                            <option key={i} value={i}>
                                {i}
                            </option>
                        )
                )}
            </select>
        </span>
    );
};

export default DaySelect;
